import { qsa } from "@fluorescent/dom";
import {
  FadeUpReveal,
  intersectionWatcher,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  fadeUp: ".animation-fade-up-reveal",
};

export default node => {
  console.log("animate blog");
  let observer = null;
  const fadeUpItems = qsa(selectors.fadeUp, node);
  const reveals = [];

  if (shouldAnimate(node)) {
    // Initialize animations and intersection observer
    fadeUpItems.forEach(item => {
      reveals.push(new FadeUpReveal(item));
    });

    observer = intersectionWatcher(node, { cb: isVisible });
  }

  function isVisible() {
    let delay = 0;
    reveals.forEach(reveal => {
      reveal.play(delay);
      delay += window.theme.animation.delay;
    });
  }

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
